import {
  Component,
  computed,
  ElementRef,
  inject,
  input,
  OnDestroy,
  OnInit,
  output,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  NgbDate,
  NgbDateAdapter,
  NgbDatepickerModule,
  NgbModal,
  NgbModalModule,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';

import { LunarDatepickerComponent } from '../lunar-datepicker/lunar-datepicker.component';
import { ClickStopPropagationDirective } from '../../directives';

@Component({
  selector: 'app-flight-datepicker',
  templateUrl: './flight-datepicker.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgbModalModule,
    NgbDatepickerModule,
    LunarDatepickerComponent,
    ClickStopPropagationDirective,
  ],
})
export class FlightDatepickerComponent implements OnInit, OnDestroy {
  private subscriptions$: Subscription[] = [];
  private content = viewChild<TemplateRef<any>>('content');
  private body = viewChild<ElementRef>('body');
  private modalService = inject(NgbModal);
  private ngbDateAdapter = inject(NgbDateAdapter<Date>);
  private fb = inject(FormBuilder);
  private modalRef?: NgbModalRef;
  private today = computed(() => {
    const dateStruct = this.ngbDateAdapter.fromModel(new Date())!;
    return new NgbDate(dateStruct.year, dateStruct.month, dateStruct.day);
  });
  headerTitle = input('Chọn ngày');
  selected = output<NgbDate>();
  dataForm!: FormGroup;

  ngOnInit(): void {
    this.initForm();
  }

  ngOnDestroy(): void {
    this.subscriptions$.forEach((s) => s?.unsubscribe());
  }

  open(initDate?: NgbDate) {
    this.dataForm.reset({ date: initDate });
    this.modalRef = this.modalService.open(this.content(), {
      centered: false,
      size: 'lg',
    });
  }

  onSelect(value: NgbDate[]) {
    this.selected.emit(value[0]);
    this.modalRef?.close();
  }

  private initForm() {
    this.dataForm = this.fb.group({
      date: [this.today()],
    });
  }
}
